import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-100 my-6" }
const _hoisted_2 = { class: "w-100 d-flex" }
const _hoisted_3 = { class: "mx-auto mt-0 mb-4" }
const _hoisted_4 = { class: "w-50 d-flex mx-auto cols-12 mt-2" }
const _hoisted_5 = { class: "w-75 cols-5" }
const _hoisted_6 = { class: "text-title-large font-weight-bold" }
const _hoisted_7 = { class: "w-50 d-flex mx-auto cols-12 mt-2" }
const _hoisted_8 = { class: "w-75 cols-5" }
const _hoisted_9 = { class: "text-label-large font-weight-bold" }
const _hoisted_10 = { class: "w-100 d-flex cols-7" }
const _hoisted_11 = { class: "w-50 d-flex mx-auto cols-12 mt-2" }
const _hoisted_12 = { class: "w-75 cols-5" }
const _hoisted_13 = { class: "text-label-large font-weight-bold" }
const _hoisted_14 = { class: "w-100 d-flex cols-7" }
const _hoisted_15 = { class: "w-50 d-flex mx-auto cols-12 mt-2" }
const _hoisted_16 = { class: "w-75 cols-5" }
const _hoisted_17 = { class: "text-label-large font-weight-bold" }
const _hoisted_18 = { class: "w-100 d-flex cols-7" }

import { formatDateTime } from '@/services/functions';
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'RegisterModalContent',
  props: {
    combineItems: {}
  },
  setup(__props: any) {

const props = __props;

function changeFormat(dateTime: Date | string) {
  return typeof dateTime === 'string' ? formatDateTime(new Date(dateTime)) : formatDateTime(dateTime);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", _hoisted_3, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.combineForm.registerModal.message')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.combineForm.registerModal.afterDeliveryPlans')), 1)
      ]),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "w-100 d-flex cols-7" }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.combineForm.registerModal.driver')), 1)
      ]),
      _createElementVNode("div", _hoisted_10, _toDisplayString(props.combineItems.driverName), 1)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.combineForm.registerModal.leavingWarehouse')), 1)
      ]),
      _createElementVNode("div", _hoisted_14, _toDisplayString(changeFormat(props.combineItems.start)), 1)
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.combineForm.registerModal.returningWarehouse')), 1)
      ]),
      _createElementVNode("div", _hoisted_18, _toDisplayString(changeFormat(props.combineItems.end)), 1)
    ])
  ]))
}
}

})